/* PLTX2 Reviews Summary — v2 */
(function() {
  'use strict';

  var section = document.querySelector('.pltx2-summary');
  if (!section) return;

  var apiBase = section.getAttribute('data-api-base') || '';
  var productId = section.getAttribute('data-product-id') || '';

  /* Product group (colorway siblings share one merged summary) */
  var groupIds = [productId];
  try {
    var cfgEl = section.querySelector('script[data-pltx2-review-group]');
    if (cfgEl) {
      var parsed = JSON.parse(cfgEl.textContent);
      if (parsed && parsed.ids && parsed.ids.length) groupIds = parsed.ids.map(String);
    }
  } catch (e) { console.warn('[pltx2-summary] group config parse failed', e); }

  /* === Fetch combined summary (weighted average across the group) === */
  function fetchSummary() {
    if (!apiBase || !groupIds.length) return;
    Promise.all(groupIds.map(function(id) {
      return fetch(apiBase + '/api/reviews/summary/' + id)
        .then(function(r) { return r.json(); })
        .catch(function() { return null; });
    }))
      .then(function(all) {
        var total = 0, weighted = 0;
        for (var gi = 0; gi < all.length; gi++) {
          var s = all[gi];
          if (!s || s.error) continue;
          var c = s.totalCount || 0;
          total += c;
          weighted += (parseFloat(s.averageRating) || 0) * c;
        }
        var avg = total > 0 ? weighted / total : 0;

        // Update stars via <use> fill — preserve animation targets
        var starsWrap = document.getElementById('pltx2SummaryStars');
        if (starsWrap) {
          var svgs = starsWrap.querySelectorAll('svg');
          var floor = Math.floor(avg);
          var frac = avg - floor;
          for (var i = 0; i < svgs.length; i++) {
            var starNum = i + 1;
            if (starNum <= floor) {
              // Full gold star — update <use> fill
              var use = svgs[i].querySelector('use');
              if (use) use.setAttribute('fill', '#F5B800');
            } else if (starNum === floor + 1 && frac > 0) {
              // Partial star — clipPath with <use> refs
              var pct = Math.round(frac * 24);
              var clipId = 'pltx2-sc-' + starNum;
              svgs[i].innerHTML = '<defs><clipPath id="' + clipId + '"><rect x="0" y="0" width="' + pct + '" height="24"/></clipPath></defs>' +
                '<use href="#pltx2-star" fill="#E0E0E0"/>' +
                '<use href="#pltx2-star" fill="#F5B800" clip-path="url(#' + clipId + ')"/>';
            }
            // Empty stars keep their #E0E0E0 fill (set in Liquid)
          }
          starsWrap.setAttribute('aria-label', avg.toFixed(1) + pltxT('pltx2.js.k003', ' מתוך 5'));
        }

        // Store avg + total for rolling counter (triggered by IntersectionObserver)
        var countEl = document.getElementById('pltx2SummaryCount');
        if (countEl) {
          countEl.setAttribute('data-avg', avg.toFixed(1));
          countEl.setAttribute('data-total', total);
        }
        dataReady = true;
        startEntry();
      })
      .catch(function(err) {
        console.error('[pltx2-summary] fetch error:', err);
        dataReady = true;
        startEntry();
      });
  }

  /* === PolyMarket-style rolling digit counter === */
  function buildRollingNumber(numStr, rollDuration) {
    var html = '<span class="pltx2-roll">';
    for (var i = 0; i < numStr.length; i++) {
      var ch = numStr[i];
      if (ch >= '0' && ch <= '9') {
        html += '<span class="pltx2-roll__col" data-target="' + parseInt(ch) + '" style="transform:translateY(0);transition-duration:' + rollDuration + 'ms">';
        for (var d = 0; d <= 9; d++) html += '<span class="pltx2-roll__digit">' + d + '</span>';
        html += '</span>';
      } else {
        html += '<span class="pltx2-roll__sep">' + ch + '</span>';
      }
    }
    html += '</span>';
    return html;
  }

  function buildRollingAvg(avgStr) {
    var dotSeen = false;
    var html = '<span class="pltx2-roll">';
    for (var i = 0; i < avgStr.length; i++) {
      var ch = avgStr[i];
      if (ch === '.') { dotSeen = true; html += '<span class="pltx2-roll__sep">.</span>'; continue; }
      if (ch >= '0' && ch <= '9') {
        var dur = dotSeen ? 600 : 1400;
        html += '<span class="pltx2-roll__col" data-target="' + parseInt(ch) + '" style="transform:translateY(0);transition-duration:' + dur + 'ms">';
        for (var d = 0; d <= 9; d++) html += '<span class="pltx2-roll__digit">' + d + '</span>';
        html += '</span>';
      } else {
        html += '<span class="pltx2-roll__sep">' + ch + '</span>';
      }
    }
    html += '</span>';
    return html;
  }

  function animateCount(el, totalNum, avgStr) {
    var totalStr = totalNum.toLocaleString();
    var digitCount = totalStr.replace(/\D/g, '').length;
    var rollDuration = 1200 + Math.min(digitCount * 60, 300);

    var html = '';
    if (avgStr) {
      html += '<span class="pltx2-summary__count-avg" style="opacity:0">' + buildRollingAvg(avgStr) + '</span>';
      html += '<span class="pltx2-summary__count-sep" style="opacity:0"></span>';
    }
    html += '<span class="pltx2-summary__count-total" style="opacity:0">' + buildRollingNumber(totalStr, rollDuration) + '' + pltxT('pltx2.js.k001', ' ביקורות') + '</span>';
    el.innerHTML = html;

    var avgEl = el.querySelector('.pltx2-summary__count-avg');
    var sepEl = el.querySelector('.pltx2-summary__count-sep');
    var totalEl = el.querySelector('.pltx2-summary__count-total');

    // Triple safety: RAF + RAF + setTimeout ensures paint before transition
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        setTimeout(function() {
        if (avgEl) {
          avgEl.style.transition = 'opacity 0.2s ease';
          avgEl.style.opacity = '1';
          avgEl.querySelectorAll('.pltx2-roll__col').forEach(function(col, idx) {
            var target = parseInt(col.getAttribute('data-target'));
            col.style.transitionDelay = (idx * 40) + 'ms';
            col.style.transform = 'translateY(' + -(target * 100) + '%)';
          });
        }
        if (sepEl) setTimeout(function() { sepEl.style.transition = 'opacity 0.15s ease'; sepEl.style.opacity = '1'; }, 200);
        setTimeout(function() {
          if (totalEl) {
            totalEl.style.transition = 'opacity 0.2s ease';
            totalEl.style.opacity = '1';
            totalEl.querySelectorAll('.pltx2-roll__col').forEach(function(col, idx) {
              var target = parseInt(col.getAttribute('data-target'));
              col.style.transitionDelay = (idx * 50) + 'ms';
              col.style.transform = 'translateY(' + -(target * 100) + '%)';
            });
          }
        }, 350);
        }, 16); // 16ms safety delay ensures paint
      });
    });
  }

  /* === Entry animation ===
     Runs once the section is on screen AND the merged summary has arrived. It used to
     start on visibility alone: when the three colourway fetches landed after the section
     scrolled in, it read the placeholder "0 reviews", skipped the count and never retried
     — the section stayed on "0 ביקורות". The count and stars stay hidden (CSS) until
     --visible, so nothing wrong ever shows. */
  var dataReady = false;
  var seen = false;
  var started = false;

  function startEntry() {
    if (started || !seen || !dataReady) return;
    started = true;
    section.classList.add('pltx2-summary--visible');
    var countEl = document.getElementById('pltx2SummaryCount');
    if (!countEl) return;
    var avg = countEl.getAttribute('data-avg') || '';
    var total = parseInt(countEl.getAttribute('data-total'), 10) || 0;
    countEl.textContent = ''; // never leave the "0" placeholder on screen
    if (total > 0) {
      setTimeout(function() { animateCount(countEl, total, avg); }, reducedMotion ? 0 : 1250);
    }
  }

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reducedMotion) {
    var animObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          seen = true;
          startEntry();
          animObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    animObs.observe(section);
  } else {
    seen = true;
  }
  // If the API never answers, still reveal the title and stars rather than an empty block.
  setTimeout(function() { dataReady = true; startEntry(); }, 6000);

  /* === Init === */
  fetchSummary();
})();
